import React from "react";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

export default function FloatingAddButton(props) {
  return (
    <Fab color="primary" size="small" aria-label="add" className={props.classes} onClick={props.onClick}>
      <AddIcon />
    </Fab>
  );
}
